
import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useFormik } from 'formik';
import utilsService, { TOAST_TYPE } from '../../helpers/utils'
import TextInput from '../../shared/Fields/TextInput';
import st26service from '../../services/st26service';
import { useSelector } from 'react-redux';
import Checkbox from "@material-ui/core/Checkbox";


const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
        width: '96%',
        margin: '0 auto 28px',
        minHeight: '260px',
        // borderBottom: '1px solid #cec7c7',
        padding: '23px 16px 14px',
    },
    headerPipe: {
        margin: '0 10px'
    },
    searchInput: {
        width: '30%'
    },
    buttonStyleCancel: {
        float: 'right',
        textTransform: 'none',
        margin: '4px',
        color: 'white',
        backgroundColor: '#008EC5 !important',
        border: '1px solid #1F4E79 !important',
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        }
    },

    antibodyNumInput: {
        width: '8%'
    },

    colorConDSI: {
        backgroundColor: 'gainsboro',
        // marginTop: '-38px',
        padding: '28px',
        paddingTop: '28px',
        paddingBottom: '65px',
        // marginLeft: '7px',
        // marginRight: '7px',
        paddingRight: '10px',
        borderRadius: '5px',
    },
    frameBox: {
        backgroundColor: '#f8f9fa',
        borderLeft: '4px solid #007bff',
    },
    colorConDSIDark: {
        backgroundColor: 'rgba(238, 238, 238, 0.12)',
        // marginTop: '-38px',
        padding: '28px',
        paddingTop: '28px',
        paddingBottom: '65px',
        // marginLeft: '7px',
        // marginRight: '7px',
        paddingRight: '10px',
        borderRadius: '5px',
    },
    modalBody: {
        paddingBottom: '20px'
    },
    footerDiv: {
        padding: '0 10px'
    },
    loginSubmitCancel: {
        backgroundColor: '#0182C5',
        borderColor: '#1F4E79',
        border: '1px solid #1F4E79',
        color: 'white',
        margin: '4px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#0182C5',
            boxShadow: 'none',
        },
    },
    modaltext: {
        position: 'absolute',
        top: '10px',
        right: '10px'
    },
    modalClassConDSI: {
        position: 'absolute',
        width: '96%',
        padding: '35px 15px 15px',
        // height: 'auto',
        // top: '30%',
        // left: '50%',
        right: 'auto',
        bottom: 'auto',
        // transform: 'translate(-50%, -50%)'
    },
    modalClassConDSIDark: {
        position: 'absolute',
        width: '96%',
        padding: '35px 15px 15px',
        // height: 'auto',
        // top: '30%',
        // left: '50%',
        right: 'auto',
        bottom: 'auto',
        backgroundColor: '#292929'
        // transform: 'translate(-50%, -50%)'
    },
    modalBoxContent: {
        maxHeight: '675px',
    },
}));

var TranslationView = [];
function TranslationTool() {
    const { t, i18n } = useTranslation('common');

    const classes = useStyles();
    const history = useHistory();
    // const [strategy, setStrategy] = useState('genepast');
    const [authInfo, setAuthInfo] = useState();
    // const [workflowId, setWorkflowId] = useState();
    const [formdata, setFormData] = useState({});
    const { workflowId } = useParams();
    const toastRef = useRef(null)
    const [modalShow, setModalShow] = React.useState(false);
    const toggle = useSelector(state => state.setToggle.toggle);
    const [forward, setForward] = React.useState(true);
    const [reverse, setReverse] = React.useState(false);
    const [getResponse, setGetResponse] = useState('');
    // const [frames, setFrames] = useState([]);
    const [frames, setFrames] = useState('');
    const [checkboxError, setCheckboxError] = useState('');
    const [uploadedFileContent, setUploadedFileContent] = useState('');
    const [showCopyButton, setShowCopyButton] = React.useState(false);
    const [chunkSizeError, setChunkSizeError] = useState('');
    const [selectedFrames, setSelectedFrames] = useState({
        '+1': true,
        '+2': false,
        '+3': false,
        '-1': false,
        '-2': false,
        '-3': false,
        'all': false,
    });
    const [value, setValue] = React.useState('60');

    const handleCheckboxChange = (frame) => {
        setSelectedFrames((prev) => {
            let updated;
    
            if (frame === 'all') {
                const newValue = !prev['all'];
                updated = {
                    '+1': newValue,
                    '+2': newValue,
                    '+3': newValue,
                    '-1': newValue,
                    '-2': newValue,
                    '-3': newValue,
                    'all': newValue,
                };
            } else {
                updated = {
                    ...prev,
                    [frame]: !prev[frame],
                };
    
                const allChecked = ['+1', '+2', '+3', '-1', '-2', '-3'].every(f => updated[f]);
                updated['all'] = allChecked;
            }
    
            setFrames([]);  // This enables Translate button again
            setShowCopyButton(false);
            return updated;
        });
    };
    
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = function (e) {
                const content = e.target.result;
                setUploadedFileContent(content);
                formik.setFieldValue('st26input', content); // optional
            };
            reader.readAsText(file);
        }
    };
    const handleValue = (event) => {
        const val = event.target.value;
        // Allow only digits
        if (!/^\d*$/.test(val)) return;
        const num = parseInt(val, 10);
        if (val && (!num || num > 150)) {
            setChunkSizeError("should be less than or equal to 150");
            setFrames([]);
            setShowCopyButton(false);
          } else {
            setChunkSizeError('');
          }
        setValue(val); //only set if valid
      };
      

    const copytoclipboard = async () => {
        if (!frames || frames.length === 0) {
            utilsService.showToast(TOAST_TYPE.ERROR, "No translated frames to copy.", toastRef);
            return;
        }

        const textToCopy = frames.map(frame => `${frame.title}\n${frame.sequence}\n\n`).join('');
    
        try {
            await navigator.clipboard.writeText(textToCopy);
            utilsService.showToast(TOAST_TYPE.SUCCESS, "Copied to clipboard!", toastRef);
        } catch (err) {
            console.error("Clipboard copy failed:", err);
            utilsService.showToast(TOAST_TYPE.ERROR, "Failed to copy to clipboard.", toastRef);
        }
    };
    


    const handleConverted = async () => {
        const input = formik.values.st26input;


        // 2. Split into lines
        const lines = input.trim().split('\n');

        // 3. If first line is a FASTA header, validate it
        if (lines[0].startsWith('>')) {
            const header = lines[0].slice(1); // remove the '>'
            const validHeaderRegex = /^[a-zA-Z0-9 _-]+$/;
            if (!validHeaderRegex.test(header)) {
                utilsService.showToast(
                    TOAST_TYPE.ERROR,
                    "FASTA header contains invalid characters. Only letters, digits, spaces, underscores, and hyphens are allowed after '>'.",
                    toastRef
                );
                return;
            }
        }

        // 4. Remove all FASTA header lines (lines starting with '>') and join sequence
        const cleanedSequence = lines
            .filter(line => !line.startsWith('>'))
            .join('')
            .replace(/\s/g, '');

        // 5. Validate DNA sequence
        const validDNARegex = /^[ATCGNUatcgnu]+$/;
        if (!cleanedSequence || cleanedSequence.length < 3) {
            utilsService.showToast(
                TOAST_TYPE.ERROR,
                "The sequence is too short to translate. Minimum 3 DNA bases required.",
                toastRef
            );
            setFrames([]);
            return;
        }

        // if (!validDNARegex.test(cleanedSequence)) {
        //     utilsService.showToast(
        //         TOAST_TYPE.ERROR,
        //         "Invalid characters found. Only A, T, C, G, U are allowed in the DNA sequence.",
        //         toastRef
        //     );
        //     setFrames([]);
        //     return;
        // }

        // Other validations: frames, line length
        const selected = Object.values(selectedFrames).some(val => val);
        if (!selected) {
            utilsService.showToast(TOAST_TYPE.ERROR, "Please select at least one frame", toastRef);
            return;
        }

        if (parseInt(value) === 0) {
            utilsService.showToast(TOAST_TYPE.ERROR, "Amino acids per line must be greater than 0", toastRef);
            return;
        }

        // Proceed to conversion
        const postData = { st26input: input };

        let frames = Object.entries(selectedFrames)
            .filter(([_, isChecked]) => isChecked)
            .map(([frame]) => frame);

        if (frames.includes('all')) {
            frames = ['+1', '+2', '+3', '-1', '-2', '-3'];
        }

        try {
            const response = await st26service.convertDNAFastaToProteins(postData, frames);

            // if (!response || !Array.isArray(response.translations)) {
            //     utilsService.showToast(TOAST_TYPE.ERROR, "Unexpected response from server.", toastRef);
            //     return;
            // }
            if(response.parsererror){
                utilsService.showToast(TOAST_TYPE.ERROR, "Invalid characters found", toastRef);

            }
            if(parseInt(value) > 150){
                return;
            }

            const parsedFrames = response.translations.map((item, index) => ({
                title: item.title || `Frame ${index + 1}`,
                sequence: wrapSequence(item.sequence || "", parseInt(value))
            }));

            setFrames(parsedFrames);
            setModalShow(true);
        } catch (error) {
            console.error("Error during conversion:", error);
            utilsService.showToast(
                TOAST_TYPE.ERROR,
                "An error occurred during conversion. Please check your input.",
                toastRef
            );
        }
        setShowCopyButton(true); 
    };


    function showfil() {
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            var preview = document.getElementById('fastaInput');
            var file = document.querySelector('input[type=file]').files[0];
            var reader = new FileReader();

            var textFile = /text.*/;
            if (file.type.match(textFile)) {
                reader.onload = function (event) {
                    // preview.innerHTML = event.target.result;
                    preview.value = event.target.result;
                    formik.setFieldValue("st26input", event.target.result);
                };
            } else {
                preview.innerHTML =
                    "<span class='error'>It doesn't seem to be a text file!</span>";
            }
            reader.readAsText(file);
        } else {
            alert('Your browser is too old to support HTML5 File API');
        }

    }
    function resetFileInput() {
        var fileInput = document.querySelector('input[type=file]');
        fileInput.value = '';
    }
    function fileNames() {
        var fileInput = document.querySelector('input[type=file]');
        var file = fileInput.files[0];

        if (file === undefined || file.name === null || file.name === "") {
            var fileName = prompt("Please enter the name of the file:");
            console.log(fileName, "filename");
            return fileName;
        } else {
            return file.name;
        }
    }
    function wrapSequence(sequence, chunkSize) {
        const lines = [];
        for (let i = 0; i < sequence.length; i += chunkSize) {
            const line = sequence.slice(i, i + chunkSize);
            const spacedLine = line.match(/.{1,10}/g).join(' ');
            lines.push(spacedLine);
        }
        return lines.join('\n');
    }



    function cncl() {
        history.push('/home');
    }
    
    const clear = () => {
        formik.resetForm({
            values: {
              st26input: ''  // sets the text box to empty
            }
          });
        setFrames([]);
        setSelectedFrames([]);
        setValue('60');
        setShowCopyButton(false);
        setChunkSizeError('');
        // setSelectedFile(null);  // if you're storing uploaded file
        // if (fileInputRef.current) {
        //   fileInputRef.current.value = null; // resets actual file input
        // }
      };

    const formik = useFormik({
        initialValues: {
            st26input: formdata.st26input

        },
        enableReinitialize: true,
        //validationSchema: Validate.AntibodySearchValidation(),
        onSubmit: async (values) => {
            const postData = {
                st26input: values.st26input
            };

            const response = st26service.convertDNAFastaToProteins(postData, frames);


            const parsedFrames = response.translations.map((item, index) => ({
                title: item.title || `Frame ${index + 1}`,
                sequence: item.sequence || ""
            }));
            TranslationView = getResponse;
            setFrames(parsedFrames);
        }
    });


    return (
        <div className={classes.grow}>
            <form name="antibodySearchForm" onSubmit={formik.handleSubmit} className={classes.loginDiv}>

                <Row>
                    <Col lg="12" md="12" className={"mb-2 " + (authInfo && !authInfo.syscontrol_search_submit ? 'd-block' : 'd-none')}>
                        <Typography className="text-danger">
                            {t('ABsearchDisableText')}
                            {authInfo && authInfo.syscontrol_search_submit_txt}
                            {t('patienceThanksText')}</Typography>
                    </Col>

                    <Col lg="12" md="12" className="mb-2">
                        <h6 className={"appTextColor loginTitle"}>Translation Sequence Input</h6>
                        <Row className="mb-3">

                            <Col lg="12" md="12" className="p-0 content float-left">
                               
                                <div className="form-group px-3 ">
                                    <TextInput
                                        spellcheck="false"
                                        rows="20"
                                        multiline={true}
                                        fullWidth

                                        id="fastaInput"
                                        name="st26input"
                                        label="Copy and Paste your FASTA/Nucleotide sequences here"
                                        variant="outlined"
                                        value={formik.values.st26input}
                                        onChange={(event) => {
                                            formik.handleChange({ ...event });
                                            if (!event.target.value) {
                                                resetFileInput(); // Clear file input when text input is cleared
                                            }
                                        }}
                                        error={formik.touched.st26input && Boolean(formik.errors.st26input)}
                                        helperText={formik.errors.st26input}
                                    //disabled={authInfo && authInfo.redo}
                                    />
                                </div>

                                {checkboxError && (
                                    <div className="text mb-2 ml-2" style={{ fontSize: '0.9rem' }}>
                                        {checkboxError}
                                    </div>
                                )}

                                <p className='uploadTextData'> <b id="show-text">Upload .txt file</b></p>
                                <input type="file" accept=".txt" onChange={showfil} />

                            </Col>

                        </Row>
                    </Col>

                    <Col lg="12" md="12" className="float-right mb-3">
                        <h6> Select the Frame/Frames</h6>
                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'center' }}>
                            {['+1', '+2', '+3', '-1', '-2', '-3', 'all'].map((frame) => (
                                <label
                                    key={frame}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '1px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        userSelect: 'none',
                                    }}
                                >
                                    <span>{frame}</span>
                                    <Checkbox
                                        color="primary"
                                        checked={selectedFrames[frame]}
                                        onChange={() => handleCheckboxChange(frame)}
                                        style={toggle ? { color: 'black' } : { color: 'white' }}
                                    />
                                </label>
                            ))}
                        </div>
                        <br></br>
                        <div style={{gap: '0.5rem' }}>
                        <label htmlFor="al">
                            No. of amino acids per line (max: 150):
                        </label>
                        <input
                            type='text'
                            size='3'
                            name='al'
                            value={value}
                            onChange={handleValue}
                            style={{ marginLeft: '0.3rem', marginRight: '0.3rem' }}
                        />
                        {chunkSizeError && (
                            <span style={{ color: 'red', fontSize: '0.9rem', whiteSpace: 'nowrap' }}>
                            should be less than or equal to 150
                            </span>
                        )}
                        </div>

                        {(!formik.values.st26input || formik.values.st26input.trim() === '') ?
                            <Button className='cancelButtonDisable' color="default" variant="contained" onClick={() => handleConverted()}>Translate</Button>
                            :
                            <Button className='accountInfo' color="default" type="submit" variant="contained" onClick={() => handleConverted()}>Translate</Button>
                        }
                        <Button variant="contained" disableRipple={true} color="default" className={classes.buttonStyleCancel} style={{marginRight: '8px'}}onClick={cncl}>{t('cancel')}</Button>
                        <Button variant="contained" disableRipple={true} color="default" className={classes.buttonStyleCancel} onClick={clear}>{'Clear'}</Button>
                    </Col>

                </Row>
                {frames.length > 0 ? (
                    <div className="form-group px-3">
                        <h6 className="font-weight-bold" >Translated Frames</h6>
                        <pre className="bg-light p-2 rounded text-break "
                    >
                    {frames.map((frame) =>
                        `${frame.title.replace(/\s+/g, '_')}\n${frame.sequence}\n\n`
                    ).join('')}
                    </pre>

                    </div>
                ) : (
                    <p></p>
                )}
                {!showCopyButton  ?
                    <Button className='cancelButtonDisable' color="default" disableRipple={true} variant="contained" onClick={() => copytoclipboard()}>Copy the Translated Sequences to Clipboard</Button>
                    : <Button className='accountInfo' color="default" disableRipple={true} type="submit" variant="contained" onClick={() => copytoclipboard()}>Copy the Translated Sequences to Clipboard</Button>
                }
            </form>

        </div>

    )

}

export default TranslationTool;